import { ChevronDown, ChevronRight } from "lucide-react";
import { useId, useState } from "react";

type FilterGroupProps<T extends string | number> = {
  title: string;
  options: T[];
  selected: T[];
  onToggle: (value: T) => void;
  format?: (value: T) => string;
};

export function FilterGroup<T extends string | number>({
  title,
  options,
  selected,
  onToggle,
  format = (value) => String(value),
}: FilterGroupProps<T>) {
  const [open, setOpen] = useState(true);
  const reactId = useId();
  const optionsId = `${reactId}-options`;

  return (
    <fieldset className="filter-group">
      <legend>
        <button
          className="filter-group__toggle"
          type="button"
          aria-controls={optionsId}
          aria-expanded={open}
          onClick={() => setOpen((current) => !current)}
        >
          <span>{title}</span>
          {selected.length > 0 ? (
            <span className="filter-group__count">{selected.length}</span>
          ) : null}
          {open ? (
            <ChevronDown size={15} aria-hidden="true" />
          ) : (
            <ChevronRight size={15} aria-hidden="true" />
          )}
        </button>
      </legend>
      {open ? (
        <div className="filter-group__options" id={optionsId}>
          {options.map((option) => {
            const id = `${title}-${option}`.replace(/\s+/g, "-").toLowerCase();
            return (
              <label className="check-pill" htmlFor={id} key={String(option)}>
                <input
                  checked={selected.includes(option)}
                  id={id}
                  onChange={() => onToggle(option)}
                  type="checkbox"
                />
                <span>{format(option)}</span>
              </label>
            );
          })}
        </div>
      ) : null}
    </fieldset>
  );
}
